/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Custom_NodesInputs */

const en_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom nodes`)
};

const ar_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عقد مخصصة`)
};

const bn_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাস্টম নোড`)
};

const de_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Knoten`)
};

const es_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodos personalizados`)
};

const fr_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nœuds personnalisés`)
};

const pt_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nós personalizados`)
};

const zh_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义节点`)
};

const tr_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel düğümler`)
};

const ru_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательские узлы`)
};

const pl_svchip_custom_nodes = /** @type {(inputs: Svchip_Custom_NodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Węzły niestandardowe`)
};

/**
* | output |
* | --- |
* | "Custom nodes" |
*
* @param {Svchip_Custom_NodesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_custom_nodes = /** @type {((inputs?: Svchip_Custom_NodesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Custom_NodesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_custom_nodes(inputs)
	if (locale === "bn") return bn_svchip_custom_nodes(inputs)
	if (locale === "de") return de_svchip_custom_nodes(inputs)
	if (locale === "es") return es_svchip_custom_nodes(inputs)
	if (locale === "fr") return fr_svchip_custom_nodes(inputs)
	if (locale === "pt") return pt_svchip_custom_nodes(inputs)
	if (locale === "zh") return zh_svchip_custom_nodes(inputs)
	if (locale === "tr") return tr_svchip_custom_nodes(inputs)
	if (locale === "ru") return ru_svchip_custom_nodes(inputs)
	if (locale === "pl") return pl_svchip_custom_nodes(inputs)
	return en_svchip_custom_nodes(inputs)
});